export const AppPermissionConsts = {
  Approvals: {
    Default: 'HarvestActivityReportWeb.Approvals',
    Approve: 'HarvestActivityReportWeb.Approvals.Approve'
  }
};
